// Theme variables injected by gulp
var THEME_NAME;

THEME_NAME = 'bogen';

angular.module('app.controllers').controller('BoothsCtrl', ['$scope', '$rootScope', 'UI'].append(function(self, root, UI) {
  self.exhibitor = '';
  self.booths = [];
  self.$on('onBoothModalOpen', function(event, data) {
    self.exhibitor = data.details;
    self.booths = data.boothes;
    return self.boothsModal.show();
  });
  self.boothsModalEl = document.getElementById('boothsModal');
  if (self.boothsModalEl) {
    self.boothsModal = bootstrap.Modal.getOrCreateInstance(self.boothsModalEl);
    self.boothsModalEl.addEventListener('hidden.bs.modal', function(event) {
      self.exhibitor = '';
      self.booths = [];
      return self.$applyAsync();
    });
    return self.boothsModalEl.addEventListener('shown.bs.modal', function(event) {
      return self.$applyAsync();
    });
  }
}));
